import { NBIDiaryLocalStoragePrefix, NgStorage, StorageDiaryKey, StorageAdminKey } from './types';

const NS = 'LocalStorageService'; // jshint ignore:line

class LocalStorageService {
  private prefix: string;
  private isDiaryMobile: boolean;

  public init(prefix: string = '', isDiaryMobile = false): void {
    this.prefix = prefix ? prefix : NBIDiaryLocalStoragePrefix;
    this.isDiaryMobile = isDiaryMobile;
  }

  public get(key: string): any {
    let value;

    const prefix = this.getStoragePrefixKey(key);
    const storageKey = prefix + key;

    value = localStorage?.getItem(storageKey);
    if (!this.isDiaryMobile && this.getStoragePrefixKey(key) && !value) {
      const oldKey = NgStorage + key;
      const oldKeyValue = localStorage?.getItem(oldKey);
      value = oldKeyValue ? JSON.parse(oldKeyValue) : null;
      console.log(NS, `Couldn't find token with new prefix, trying old angularJS prefix`, value);
    } else {
      value = value ? JSON.parse(value) : null;
    }

    /**
     * Just in case local storage not stringified properly before being set
     */
    if (value === 'null') {
      return null;
    }

    return value;
  }

  public set(key: string, value: any): void {
    if (value === undefined || value === null) {
      console.warn(
        NS,
        'set',
        'You are attempting to save a falsy value to local storage. This might not work as expected. Use LocalStorageService.remove instead.',
        value
      );
    }

    const prefix = this.getStoragePrefixKey(key);
    const storageKey = prefix + key;
    localStorage.setItem(storageKey, JSON.stringify(value));
  }

  public remove(key: string): void {
    const prefix = this.getStoragePrefixKey(key);
    const storageKey = prefix + key;
    if (this.isCustomPrefixKey(key)) localStorage.removeItem(NgStorage + key);
    localStorage.removeItem(storageKey);
  }

  private getStoragePrefixKey(key: string): string {
    const isIncludedKey = this.isCustomPrefixKey(key);

    /**
     * For diary: NBIDiaryLocalStoragePrefix
     * For diary mobile: NBIDiaryMobileLocalStoragePrefix
     */
    return isIncludedKey ? this.prefix : NgStorage;
  }

  // will return true if key is in the list of non-angularJS local storage keys
  private isCustomPrefixKey(key: string): boolean {
    const isIncludedKey = StorageDiaryKey.indexOf(key) > -1 || StorageAdminKey.indexOf(key) > -1;

    return isIncludedKey;
  }
}

const instance = new LocalStorageService();
export default instance as LocalStorageService;
